import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { Wrapper } from './styles/Wrapper';
import { TProps } from './types/TProps';

export const AcceptBackupRecordingTermsModal = ({ onCancel, onSuccess }: TProps) => {
  return (
    <Wrapper>
      <ModalWrapper width="700px">
        <ModalTitle>AS1 Backup Audio Recording Feature - User Agreement</ModalTitle>

        <div className="content">
          <p>
            <b>IMPORTANT NOTICE</b>: This Backup Audio Recording Feature (the &quot;Feature&quot;) is designed to create
            a continuous audio backup recording from the time the recording session is opened within the software until
            the session is ended by the user, regardless of whether the official record is actively being recorded. This
            Feature is provided as a safeguard to assist in recovering audio data in the event the primary recording is
            lost, damaged, or corrupted. It is not intended to serve as the official record.
          </p>
          <p>
            <b>Acknowledgment and Agreement</b> By enabling and using this Feature, you, the user, acknowledge and agree
            to the following terms:
          </p>
          <ul className="mb-2">
            <li>
              Purpose and Use:
              <ul>
                <li>The backup audio recording is for internal use only and is not part of the official record.</li>
                <li>
                  The backup recording may only be used for quality assurance, troubleshooting, or recovery of lost data
                  and may not be shared, distributed, or submitted as an official transcript or record.
                </li>
              </ul>
            </li>
            <li>
              Data Responsibility:
              <ul>
                <li>
                  You are responsible for ensuring compliance with all applicable laws and regulations, including
                  privacy and data protection laws, when using this Feature.
                </li>
                <li>
                  You must inform all participants of the session that a backup recording may be created and ensure
                  appropriate consent is obtained as required by law.
                </li>
              </ul>
            </li>
            <li>
              Confidentiality and Security:
              <ul>
                <li>
                  You are solely responsible for safeguarding and securing backup audio recordings, including
                  restricting unauthorized access.
                </li>
                <li>
                  The software provider assumes no liability for unauthorized access, misuse, or loss of backup
                  recordings.
                </li>
              </ul>
            </li>
            <li>
              Limitations of Liability:
              <ul>
                <li>
                  The software provider does not guarantee the availability, quality, or accuracy of backup recordings.
                </li>
                <li>
                  The software provider is not liable for any damages resulting from the use or inability to use the
                  backup recording or its failure to properly capture audio.
                </li>
              </ul>
            </li>
            <li>
              Enabling the Feature:
              <ul>
                <li>Use of this Feature requires explicit user consent each time it is enabled.</li>
                <li>By enabling the Feature, you confirm that you have read, understood, and agreed to these terms.</li>
              </ul>
            </li>
          </ul>
          <p>
            <b>User Confirmation</b>: By clicking &quot;Agree&quot; below, you confirm that:
          </p>
          <ul>
            <li>You have reviewed and understood this agreement.</li>
            <li>
              You accept responsibility for compliance with all applicable laws regarding the use of this Feature.
            </li>
            <li>You agree to the terms and conditions outlined above.</li>
          </ul>
        </div>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Decline</OutlinedButton>
          <Button onClick={onSuccess}>Accept</Button>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};
